import { createTheme } from '@mui/material/styles';

const COLORS = {
  PRIMARY_COLOR: '#F37021',
  PRIMARY_LIGHT_COLOR: '#f7a962',
  SECONDARY_COLOR: '#FDBA12',
  WHITE_COLOR: '#FFFFFF',
};

const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.PRIMARY_COLOR,
      light: COLORS.PRIMARY_LIGHT_COLOR,
    },
    secondary: {
      main: COLORS.SECONDARY_COLOR,
    },
    white: {
      main: COLORS.WHITE_COLOR,
    },
  },
});
export default theme;
